import React, { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { AppLayoutTop } from 'components/appComponents';

import { useLazyDriverTonarAdjustmentsInfoQuery } from 'bus/driverSalaryAdjustments/services';
import { DriverSalaryAdjustmentsInfoItem } from 'bus/driverSalaryAdjustments/types';

import { BlockAdjustmentInfo, BlockAdjustmentTable } from './components';

const DriverTonarAdjustmentsDetail: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [driverTonarAdjustmentsInfo] = useLazyDriverTonarAdjustmentsInfoQuery();

  const [form, setForm] = useState<DriverSalaryAdjustmentsInfoItem>({
    comment: '',
    date: '',
    driverName: '',
    sum: 0,
  });

  const getDriverSalaryAdjustmentsInfo = useCallback(async () => {
    //const result = await dispatch(driverSalaryAdjustmentsInfo.async({ id }));
    const result = await driverTonarAdjustmentsInfo({ id }).unwrap();
    setForm(result);
  }, [driverTonarAdjustmentsInfo, id]);

  useEffect(() => {
    getDriverSalaryAdjustmentsInfo();
  }, [getDriverSalaryAdjustmentsInfo]);

  return (
    <div>
      <AppLayoutTop title="Корректировка зарплат" />
      <BlockAdjustmentInfo form={form} />
      <BlockAdjustmentTable adjustmentId={id} refreshDetail={getDriverSalaryAdjustmentsInfo} />
    </div>
  );
};

export default DriverTonarAdjustmentsDetail;
